import { DAY_KEYS } from "./constants";
const getDayName = (dayNames, date) => {
    return dayNames[DAY_KEYS[date.getDay()]];
};
export default getDayName;
